import React, { useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import LoginForm from './LoginForm';
// RegisterForm is no longer needed here
// import RegisterForm from './RegisterForm'; 

const AuthPage = () => {
  // Remove state and toggle function related to switching forms
  // const [isLogin, setIsLogin] = useState(true);
  const { user, loading } = useAuth();
  
  // Simple navigation to main app when authenticated
  useEffect(() => {
    if (user && !loading) {
      window.location.href = '/';
    }
  }, [user, loading]);

  // const toggleAuthMode = () => {
  //   setIsLogin(!isLogin);
  // };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-dark-bg-primary">
        <div className="w-12 h-12 border-4 border-blue-600 dark:border-dark-accent border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-dark-bg-primary px-4 py-12">
      <div className="mb-8 text-center">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-dark-text-primary mb-2">UIForge</h1>
        <p className="text-gray-600 dark:text-dark-text-secondary">Create beautiful user interfaces instantly</p>
      </div>
      
      {/* Always render LoginForm, remove the toggle prop */}
      <LoginForm /> 
      
      {/* Remove conditional rendering logic */}
      {/* {isLogin ? (
        <LoginForm onToggleForm={toggleAuthMode} />
      ) : (
        <RegisterForm onToggleForm={toggleAuthMode} />
      )} */}
    </div>
  );
};

export default AuthPage; 